var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyeOpenLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.08676 23.606C9.94823 21.5866 13.8742 13.9 24.0075 13.9C34.1409 13.9 38.0669 21.5867 38.9283 23.606C39.1773 24.183 39.1773 24.817 38.9283 25.394C38.0669 27.4134 34.1409 35.1 24.0075 35.1C13.8742 35.1 9.94823 27.4134 9.08676 25.394C8.83778 24.817 8.83778 24.183 9.08676 23.606ZM24.0075 16.1C15.2452 16.1 11.8702 22.6868 11.1094 24.4714L11.1069 24.4774L11.1068 24.4774C11.1028 24.4867 11.1012 24.4928 11.1006 24.4956C11.1 24.4985 11.1 24.4997 11.1 24.5C11.1 24.5003 11.1 24.5016 11.1006 24.5044C11.1012 24.5073 11.1028 24.5133 11.1068 24.5227L11.1094 24.5286L11.1094 24.5286C11.8702 26.3133 15.2452 32.9 24.0075 32.9C32.7698 32.9 36.1448 26.3133 36.9056 24.5286L36.9082 24.5226L36.9082 24.5227C36.9123 24.5133 36.9138 24.5073 36.9144 24.5044C36.915 24.5016 36.915 24.5003 36.915 24.5C36.915 24.4997 36.915 24.4985 36.9144 24.4956C36.9138 24.4928 36.9123 24.4867 36.9082 24.4774L36.9056 24.4714L36.9056 24.4714C36.1448 22.6868 32.7698 16.1 24.0075 16.1Z",
    fill: "#121619"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9976 20.6C21.8437 20.6 20.0976 22.3461 20.0976 24.5C20.0976 26.6539 21.8437 28.4 23.9976 28.4C26.1515 28.4 27.8976 26.6539 27.8976 24.5C27.8976 22.3461 26.1515 20.6 23.9976 20.6ZM17.8976 24.5C17.8976 21.1311 20.6286 18.4 23.9976 18.4C27.3665 18.4 30.0976 21.1311 30.0976 24.5C30.0976 27.869 27.3665 30.6 23.9976 30.6C20.6286 30.6 17.8976 27.869 17.8976 24.5Z",
    fill: "#121619"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOpenLight);
export default __webpack_public_path__ + "static/media/icon_eye_open_light.16054b31.svg";
export { ForwardRef as ReactComponent };